import { useQuery } from '@tanstack/react-query';
import type { SiestaSkillFile } from '../types';

export default function useTenantSkillFiles(skillId: string, enabled = true) {
  return useQuery<SiestaSkillFile[]>({
    queryKey: ['tenant', 'custom-skills', skillId, 'files'],
    enabled,
  });
}
